import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { TriangleAlert } from "lucide-react";

/**
 * Oct 2026 — shared roster-change guardrail confirmation. Both the
 * technician-week grid (multi-day) and the single-rule Pause button
 * surface the SAME 409 `requires_confirmation` shape from the backend;
 * this normalises either into one dialog.
 */
export function RosterGuardrailDialog({ warning, onCancel, onConfirm, busy }) {
  if (!warning) return null;
  const days = warning.days || [{
    weekday_name: warning.weekday_name,
    affected_bookings: warning.affected_bookings,
    earliest_date: warning.earliest_date,
    latest_date: warning.latest_date,
  }];
  return (
    <AlertDialog open onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent data-testid="roster-guardrail-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-700">
            <TriangleAlert className="w-5 h-5" /> {warning.warning || "This roster day has existing future bookings"}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-sm text-slate-600 space-y-3">
              <p>{warning.message}</p>
              <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 space-y-1.5">
                {warning.technician_name && (
                  <p className="text-xs font-semibold text-slate-700">Technician: {warning.technician_name}</p>
                )}
                {days.map((d) => (
                  <p key={d.weekday_name} className="text-xs text-slate-700" data-testid={`roster-guardrail-day-${d.weekday_name}`}>
                    <span className="font-semibold">{d.weekday_name}</span> — {d.affected_bookings} future booking{d.affected_bookings === 1 ? "" : "s"} affected
                    {d.earliest_date && d.latest_date ? ` (${d.earliest_date} → ${d.latest_date})` : ""}
                  </p>
                ))}
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="roster-guardrail-cancel" onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="roster-guardrail-confirm"
            disabled={busy}
            onClick={onConfirm}
            className="bg-rose-600 hover:bg-rose-700">
            {warning.confirm_action || "Remove roster day and preserve existing bookings"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
